import React from "react";

const Help = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            fill={fill}
            fillRule="evenodd"
            d="M33.249 6.616c-.266-1.644-1.258-2.634-2.856-2.86-.038-.01-3.93-.756-10.036-.756-6.104 0-9.995.746-10.022.752-1.25.178-2.121.819-2.574 1.855a70.323 70.323 0 0 1 7.88-.425c5.919 0 9.856.68 10.434.787 2.606.39 4.417 2.198 4.856 4.847.19.863.788 3.897.788 7.52 0 1.94-.174 3.72-.362 5.08 1.033-.438 1.682-1.313 1.887-2.577.007-.031.756-3.227.756-7.12 0-3.893-.749-7.09-.753-7.104"
            clipRule="evenodd"
        />
        <path className="u_fill"
            fill={fill}
            fillRule="evenodd"
            d="M28.532 11.234c-.265-1.645-1.258-2.635-2.855-2.862-.038-.009-3.93-.753-10.035-.753s-9.996.744-10.022.751C4.01 8.6 3.018 9.59 2.757 11.216 2.748 11.247 2 14.444 2 18.337c0 3.893.748 7.089.752 7.102.266 1.645 1.258 2.636 2.855 2.862.032.006 2.556.49 6.714.678l2.477 4.292a.975.975 0 0 0 1.688 0l2.478-4.291c4.158-.19 6.68-.672 6.7-.677 1.61-.229 2.603-1.219 2.864-2.846.009-.031.756-3.227.756-7.12 0-3.893-.748-7.09-.752-7.103Z"
            clipRule="evenodd"
        />
    </svg>
);

export default Help;
